<template>
  <div class="main-card sn-content">
    <el-button v-if="$route.query.userId" size="mini" class="pxy-primary return-button" style="margin-right: 10px;" @click="$router.go(-1)">返回</el-button>
    <el-card class="box-card clearfix">
      <!-- <el-row style="marginBottom:15px;">
        <el-col :xs="12" :sm="4">授权码列表</el-col>
      </el-row> -->
      <el-form class="search-form" ref="form" v-if="$route.query.userId">
        <el-form-item  label="用户名称：" label-width="85px">
          <el-tag effect="plain">{{$route.query.userName}}</el-tag>
        </el-form-item>
        <el-form-item label="授权码：" label-width="85px">
          <el-input v-model="sn" clearable placeholder="请输入授权码" size="small"></el-input>
        </el-form-item>
        <el-form-item label="" label-width="85px">
          <el-button class="pxy-primary" size="small" @click="formSearch()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="cloudSnList">

        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="授权码">
                <span>{{ props.row.sn }}</span>
              </el-form-item>
              <el-form-item label="标签">
                <span>{{ props.row.tag }}</span>
              </el-form-item>
              <el-form-item label="计费模式">
                <span v-if="props.row.chargeType == 2"> 按量付费</span>
                <span v-if="props.row.chargeType == 1"> 包月</span>
              </el-form-item>
              <el-form-item label="状态">
                <span v-if="props.row.status == 0"> 有效</span>
                <span class="danger" v-if="props.row.status == 1"> 无效</span>
              </el-form-item>


              <el-form-item label="授权类型">
                <span v-if="props.row.snType == 'B'"> 标准版</span>
                <span v-if="props.row.snType == 'C'"> 开发版</span>
              </el-form-item>
              <el-form-item label="最大并发数">
                <span>{{ props.row.maxConnCnt }}</span>
              </el-form-item>
              <el-form-item label="是否开启数据通道">
                <span v-if="props.row.dcsAuth == 'Y'"> 是</span>
                <span v-if="props.row.dcsAuth == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启互动模式">
                <span v-if="props.row.playModeAuth == 'Y'"> 是</span>
                <span v-if="props.row.playModeAuth == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启VR集中管控">
                <span v-if="props.row.vrRoomAuth== 'Y'"> 是</span>
                <span v-if="props.row.vrRoomAuth == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启开发版接口服务">
                <span v-if="props.row.snType== 'C'"> 是</span>
                <span v-if="props.row.snType == 'B'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启音频服务">
                <span v-if="props.row.audioInput== 'Y'"> 是</span>
                <span v-if="props.row.audioInput == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否开启视频服务">
                <span v-if="props.row.videoInput== 'Y'"> 是</span>
                <span v-if="props.row.videoInput == 'N'"> 否</span>
              </el-form-item>
              <el-form-item label="是否是行业伙伴授权">
                <span v-if="props.row.wm == '3'"> 是</span>
                <span v-else> 否</span>
              </el-form-item>
              <el-form-item label="开始时间">
                <span> {{props.row.startDate | formatDate}}</span>
              </el-form-item>
              <el-form-item label="创建时间">
                <span> {{props.row.createDate | formatDate}}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="sn" label="授权码">
        </el-table-column>
        <el-table-column prop="tag" label="标签"></el-table-column>
        <el-table-column label="计费模式">
          <template slot-scope="scope">
            <span v-if="scope.row.chargeType == 2"> 按量付费</span>
            <span v-if="scope.row.chargeType == 1"> 包月</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0"> 有效</span>
            <span class="danger" v-if="scope.row.status == 1"> 无效</span>
          </template>
        </el-table-column>
        <el-table-column label="授权类型">
          <template slot-scope="scope">
            <span v-if="scope.row.snType == 'B'"> 标准版</span>
            <span v-if="scope.row.snType == 'C'"> 开发版</span>
          </template>
        </el-table-column>
        <el-table-column prop="maxConnCnt" label="最大并发数">
        </el-table-column>
        <el-table-column label="是否开启数据通道">
          <template slot-scope="scope">
            <span v-if="scope.row.dcsAuth == 'Y'"> 是</span>
            <span v-if="scope.row.dcsAuth == 'N'"> 否</span>
          </template>
        </el-table-column>
        <el-table-column label="是否开启互动模式">
          <template slot-scope="scope">
            <span v-if="scope.row.playModeAuth == 'Y'"> 是</span>
            <span v-if="scope.row.playModeAuth == 'N'"> 否</span>
          </template>
        </el-table-column>
        <el-table-column label="是否开启VR集中管控" width="140px">
          <template slot-scope="scope">
            <span v-if="scope.row.vrRoomAuth== 'Y'"> 是</span>
            <span v-if="scope.row.vrRoomAuth == 'N'"> 否</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否开启开发版接口服务" width="140px">
          <template slot-scope="scope">
            <span v-if="scope.row.snType== 'C'"> 是</span>
            <span v-if="scope.row.snType == 'B'"> 否</span>
          </template>
        </el-table-column>
        <el-table-column label="开始时间">
          <template slot-scope="scope">
            <span> {{scope.row.createDate | formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间">
          <template slot-scope="scope">
            <span> {{scope.row.endDate | formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作" width="120px"  >
          <template slot-scope="scope">
            <router-link
              v-if="scope.row.status == 0 && scope.row.deleted === 0 "
              class="router-link-btn "
              style="color: #FF6B00;font-size: 12px"
              :to="{ path: '/userManage/snUpdate', query: { id: scope.row.id, userId: $route.query.userId,
               userName: $route.query.userName,redirect:'/userManage/sn',pPageNo:$refs.pageInfo.currentPage}}">
              更改配置
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <PageComponent ref="pageInfo"></PageComponent>
    </el-card>


  </div>
</template>

<script>
  import {Message} from "element-ui";
  import PageComponent from '@/components/pageInfo/PageComponent'

  export default {
    components: {PageComponent},
    data() {
      return {
        sn:'',
        cloudSnList: [],
        cloudSnCnt: 0,
        userQuotaForSn: {},
      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: {
      getCloudSn: function () {
        var params = {};
        params.userId = this.$route.query.userId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        if(this.sn !=="") params.sn = this.sn;//状态筛选
        this.getRequest('/pocCloudSn/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cloudSnList = resp.data.result.records;
              this.cloudSnCnt = resp.data.result.total;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      formSearch(){
        this.deleted = 0;
        this.getCloudSn()
      },
    },
    mounted: function () {
      this.getCloudSn();
      this.$refs.pageInfo.initPagenator(this.getCloudSn, null);
    },
    beforeDestroy() {

    }
  }
</script>
